import { graphql } from '@gql';

export const GET_ALL_COMPONENT_VENDORS_BY_NAME = graphql(`
    query GetAllComponentVendors($partialName: String) {
        componentVendors(where: { nameContainsFold: $partialName }) {
            edges {
                node {
                    id
                    name
                }
            }
        }
    }
`);

export const GET_COMPONENT_VENDORS_BY_IDS = graphql(`
    query GetComponentVendorById($ids: [ID!]) {
        componentVendors(where: { idIn: $ids }) {
            edges {
                node {
                    id
                    name
                }
            }
        }
    }
`);

export const GET_COMPONENT_VENDOR_AND_IDENTIFIERS = graphql(`
    query GetComponentVendorAndIdentifiers($componentId: ID) {
        components(where: { id: $componentId }) {
            edges {
                node {
                    id
                    name
                    componentVendor {
                        id
                        name
                        assessments {
                            id
                            status
                            result
                            type
                            completionTime
                        }
                    }
                    componentExternalIdentifiers {
                        id
                        source
                        externalIdentifier
                    }
                }
            }
        }
    }
`);
